export default __webpack_public_path__ + "static/media/signup.3c5c5b41.svg";